import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { ComponentItem } from "designSystem/types/component-item-types";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import Select, { SelectTextFieldProps } from "designSystem/components/select/Select";
import React, { FunctionComponent, ReactNode } from "react";

const renderItemContent = ({ id }: ComponentItem): ReactNode => (
	// customize the option
	<FlexRowCenter>
		<FiberManualRecordIcon style={{ color: id }} />
	</FlexRowCenter>
);

export interface ColorSelectProps extends SelectTextFieldProps { }

const ColorSelect: FunctionComponent<ColorSelectProps> = (props) => {
	return (
		<Select
			renderItemFunc={(item) => renderItemContent(item)}
			renderSelectedItemFunc={(item) => renderItemContent(item)}
			{...props}
		/>
	);
};

export default ColorSelect;